<script lang="ts">
    import { onMount, onDestroy, tick } from "svelte";
    import {Map, NavigationControl, Marker, setWorkerUrl} from 'maplibre-gl';
    import 'maplibre-gl/dist/maplibre-gl.css';
  
    export let lat: number;
    export let lng: number;

    setWorkerUrl(new URL(`${process.env.HUGO_BASEURL}/js/maplibre-gl-worker.mjs`).toString());
    const apiKey = process.env.ESRI_API_KEY;
    const styleUrl = `https://basemapstyles-api.arcgis.com/arcgis/rest/services/styles/v2/styles/arcgis/streets?language=local&worldview=unitedStatesOfAmerica&token=${apiKey}`;

    let locationOpen = true;
    let mapContainer: HTMLElement;
    let map: Map;
    let marker: Marker;
    let resizeObserver;
  
    async function toggleLocation() {
      locationOpen = !locationOpen;
      if (locationOpen && map) {
        await tick();
        setTimeout(() => map.resize(), 0);
      }
    }
  
    onMount(() => {
      let resizeTimeout;
  
      map = new Map({
        container: mapContainer,
        style: styleUrl,
        center: [lng, lat],
        zoom: 8
      });
  
      map.addControl(new NavigationControl({ showCompass: false }), "top-right");
  
      marker = new Marker({ color: "#007ec6" })
        .setLngLat([lng, lat])
        .addTo(map);
  
      resizeObserver = new ResizeObserver(() => {
        if (!locationOpen) return;
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => map.resize(), 100);
      });
      resizeObserver.observe(mapContainer);
    });
  
    onDestroy(() => {
      resizeObserver?.disconnect();
      marker?.remove();
      map?.remove();
    });
  </script>
  
  <div class="mini-map-wrapper" class:collapsed={!locationOpen}>
    <button
      class="info-card-header"
      on:click={toggleLocation}
      aria-expanded={locationOpen}
    >
      <span class="header-left">
        <i class="bi bi-geo-alt-fill header-icon"></i>
        Station Location
      </span>
      <i class="bi bi-chevron-{locationOpen ? 'up' : 'down'} chevron-icon"></i>
    </button>
  
    <div class="mini-map-content" class:map-hidden={!locationOpen}>
      <div class="mini-map" bind:this={mapContainer}></div>
    </div>
  </div>
  
  <style>
    .mini-map-wrapper {
      flex: 1;
      display: flex;
      flex-direction: column;
      border: 1px solid #dee2e6;
      border-radius: 8px;
      overflow: hidden;
    }
  
    .mini-map-wrapper.collapsed {
      flex: none;
    }
  
    .info-card-header {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #162e51;
      color: white;
      padding: 0.6rem 1rem;
      font-size: 0.875rem;
      font-weight: 600;
      letter-spacing: 0.02em;
      border: none;
      cursor: pointer;
      text-align: left;
      transition: background-color 0.15s ease;
    }
  
    .info-card-header:hover {
      background-color: #1e3d6e;
    }
  
    .header-left {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }
  
    .header-icon {
      font-size: 0.9rem;
      opacity: 0.9;
    }
  
    .chevron-icon {
      font-size: 0.75rem;
      opacity: 0.7;
      flex-shrink: 0;
    }
  
    .mini-map-content {
      flex: 1;
      position: relative;
      min-height: 300px;
    }
  
    .mini-map-content.map-hidden {
      display: none;
    }
  
    .mini-map {
      position: absolute;
      inset: 0;
    }
  
    @media (max-width: 900px) {
      .mini-map-content {
        min-height: 280px;
      }
    }
  </style>